<template>
  <span 
    class="icon" 
    :class="[`icon-${name}`, sizeClass]"
    :style="{ fontSize: customSize }"
  >
    {{ iconSymbol }}
  </span>
</template>

<script>
export default {
  name: 'Icon',
  
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: [String, Number],
      default: '16'
    }
  },
  
  computed: {
    sizeClass() {
      if (typeof this.size === 'string') {
        return `icon-size-${this.size}`
      }
      return ''
    },
    
    customSize() {
      if (typeof this.size === 'number') {
        return `${this.size}px`
      }
      return null
    },
    
    iconSymbol() {
      const icons = {
        'magic-wand': '✨',
        'tag': '🏷️',
        'check-circle': '✅',
        'x-circle': '❌',
        'alert-triangle': '⚠️',
        'info': 'ℹ️',
        'lightbulb': '💡',
        'search': '🔍',
        'plus': '➕',
        'edit': '✏️',
        'delete': '🗑️',
        'arrow-left': '←',
        'arrow-right': '→',
        'arrow-up': '↑',
        'arrow-down': '↓',
        'chevron-left': '‹',
        'chevron-right': '›',
        'chevron-up': '∧',
        'chevron-down': '∨',
        'menu': '☰',
        'close': '✕',
        'user': '👤',
        'users': '👥',
        'settings': '⚙️',
        'home': '🏠',
        'dashboard': '📊',
        'products': '📦',
        'sales': '💰',
        'history': '📋',
        'scanner': '📷',
        'barcode': '📏',
        'star': '⭐',
        'heart': '❤️',
        'bookmark': '🔖',
        'filter': '🔽',
        'sort': '↕️',
        'refresh': '🔄',
        'download': '⬇️',
        'upload': '⬆️',
        'save': '💾',
        'print': '🖨️',
        'copy': '📋',
        'paste': '📄',
        'cut': '✂️',
        'eye': '👁️',
        'eye-off': '🙈',
        'lock': '🔒',
        'unlock': '🔓',
        'key': '🔑',
        'mail': '📧',
        'phone': '📞',
        'calendar': '📅',
        'clock': '🕐',
        'globe': '🌐',
        'link': '🔗',
        'external-link': '↗️',
        'cloud': '☁️',
        'wifi': '📶',
        'bluetooth': '📘',
        'battery': '🔋',
        'power': '⚡',
        'volume': '🔊',
        'camera': '📷',
        'image': '🖼️',
        'video': '🎥',
        'music': '🎵',
        'file': '📄',
        'folder': '📁',
        'archive': '📦',
        'trash': '🗑️',
        'help': '❓',
        'question': '❔',
        'exclamation': '❗',
        'warning': '⚠️',
        'error': '🚫',
        'success': '✅',
        'loading': '⏳'
      }
      
      return icons[this.name] || '•'
    }
  }
}
</script>

<style scoped>
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}

.icon-size-small {
  font-size: 12px;
}

.icon-size-medium {
  font-size: 16px;
}

.icon-size-large {
  font-size: 20px;
}

.icon-size-xl {
  font-size: 24px;
}

/* Specific icon styling */
.icon-check-circle {
  color: #28a745;
}

.icon-x-circle {
  color: #dc3545;
}

.icon-alert-triangle {
  color: #ffc107;
}

.icon-info {
  color: #17a2b8;
}

.icon-warning {
  color: #ffc107;
}

.icon-error {
  color: #dc3545;
}

.icon-success {
  color: #28a745;
}
</style> 